import { render, staticRenderFns } from "./FormDesign.vue?vue&type=template&id=66db5062&scoped=true"
import script from "./FormDesign.vue?vue&type=script&lang=js"
export * from "./FormDesign.vue?vue&type=script&lang=js"
import style0 from "./FormDesign.vue?vue&type=style&index=0&id=66db5062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db5062",
  null
  
)

export default component.exports